// lokl-buchhandlung-de.js

export function loadBuchhandlungDeModule(data, adContainer) {
    // Stelle sicher, dass das adContainer-Element leer ist
    adContainer.innerHTML = '';

    // Buchanzeige erstellen
    const adElement = document.createElement('div');
    adElement.classList.add('lokl-buchhandlung-ad');

    // Buchcover
    const coverDiv = document.createElement('div');
    coverDiv.classList.add('lokl-book-cover');
    const coverImg = document.createElement('img');
    coverImg.src = data.bookCover;
    coverImg.alt = data.bookTitle;
    coverDiv.appendChild(coverImg);

    // Buchdetails
    const detailsDiv = document.createElement('div');
    detailsDiv.classList.add('lokl-book-details');

    if (data.intro) {
        const intro = document.createElement('h3');
        intro.textContent = data.intro;
        detailsDiv.appendChild(intro);
    }

    const title = document.createElement('h2');
    title.textContent = data.bookTitle;
    detailsDiv.appendChild(title);

    const author = document.createElement('p');
    author.textContent = 'Autor: ' + data.bookAuthor;
    detailsDiv.appendChild(author);

    const price = document.createElement('p');
    price.textContent = 'Preis: ' + data.bookPrice;
    detailsDiv.appendChild(price);

    if (data.bookDescription) {
        const description = document.createElement('p');
        description.textContent = data.bookDescription;
        detailsDiv.appendChild(description);
    }

    const button = document.createElement('a');
    button.href = data.bookLink;
    button.className = 'lokl-button';
    button.textContent = 'Zum Shop';
    button.target = '_blank'; // Öffnet den Link in einem neuen Tab
    detailsDiv.appendChild(button);

    // Zusammenfügen
    adElement.appendChild(coverDiv);
    adElement.appendChild(detailsDiv);

    // In den adContainer einfügen
    adContainer.appendChild(adElement);

    // Optional: Shop-Info hinzufügen
    if (data.description || data.shopName) {
        const shopInfoDiv = document.createElement('div');
        shopInfoDiv.classList.add('lokl-shop-info');

        if (data.description) {
            const shopDescription = document.createElement('p');
            shopDescription.textContent = data.description;
            shopInfoDiv.appendChild(shopDescription);
        }

        if (data.shopName && data.shopLink) {
            const shopLink = document.createElement('a');
            shopLink.href = data.shopLink;
            shopLink.textContent = data.shopName;
            shopLink.target = '_blank';
            shopInfoDiv.appendChild(shopLink);
        }

        adContainer.appendChild(shopInfoDiv);
    }
}